/**
 * Footer Manipulation
 *
 * @since 1.0.0
 * @package geo_med
 */
(function($) {
	$( 'footer .footer-content .col-2 .socials' ).wrapAll( '<li id="footer-social"></li>' );
	$( '#footer-social' ).appendTo( '#footer-menu' );

	// Fix for: Font Awsome PRO + Mozilla Firefox issue
	$( '.bulleted-list-replace li' ).prepend( '<i class="fas fa-chevron-right"></i>' );

})(jQuery);